import React from 'react'
import { UseFormReturn } from 'react-hook-form'
import { MLTShipperCreateForm as MLTShipperFormType, ShipperForm } from '@/services/shipper/schemas'
import BaseShipperForm from './BaseShipperForm'
import MultiplePlatformSection from './MultiplePlatformSection'

interface Props {
  type: 'create' | 'update'
  form: UseFormReturn<ShipperForm>
  onLogisticsServiceTypeChange?: (value: string) => void
}

function MLTShipperForm({ type, form, onLogisticsServiceTypeChange }: Props) {
  return (
    <div>
      <BaseShipperForm type={type} form={form as UseFormReturn<ShipperForm>} onLogisticsServiceTypeChange={onLogisticsServiceTypeChange} />
      <MultiplePlatformSection form={form as any} type={type} />
    </div>
  )
}

export default MLTShipperForm
